import { useEffect } from 'react';
export var useIsExpandedCallbacks = function (_a) {
    var isExpanded = _a.isExpanded, onOpen = _a.onOpen, onClose = _a.onClose;
    useEffect(function () {
        var cb = isExpanded ? onOpen : onClose;
        cb === null || cb === void 0 ? void 0 : cb();
    }, [isExpanded, onOpen, onClose]);
};
